var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseXDynamic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.76144L14.5045 0.256962C14.8466 -0.0851658 15.4013 -0.0851658 15.7434 0.256962C16.0855 0.59909 16.0855 1.15378 15.7434 1.49591L9.23897 8.00039L15.7434 14.5049C16.0855 14.847 16.0855 15.4017 15.7434 15.7438C15.4013 16.0859 14.8466 16.0859 14.5045 15.7438L8 9.23933L1.49551 15.7438C1.15338 16.0859 0.598724 16.0859 0.256596 15.7438C-0.085532 15.4017 -0.085532 14.847 0.256596 14.5049L6.76104 8.00039L0.256596 1.49591C-0.085532 1.15378 -0.085532 0.59909 0.256596 0.256962C0.598724 -0.0851658 1.15338 -0.0851658 1.49551 0.256962L8 6.76144Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXDynamic);
export default __webpack_public_path__ + "static/media/close-x-dynamic.c156f9c3910c4d1adc24aa3a78357a95.svg";
export { ForwardRef as ReactComponent };